/*
Throttling technique is used to limit the number of times a function can execute. As long as an event is happening the function will run every x time we give.
*/
const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

/*
window.addEventListener('scroll', throttle(function(){
    // your code goes here
}, 1000))
*/

export default throttle;
